import { motion, useAnimationFrame, useMotionValue, useTransform, wrap } from "framer-motion";

const ITEMS = [
  "Hospitality",
  "Wellness",
  "Startups",
  "Fitness",
  "Ecommerce",
  "Property",
  "Consulting",
  "Restaurants",
  "Retail",
  "Professional Services",
];

export const ClientStrip = () => {
  const baseX = useMotionValue(0);
  const x = useTransform(baseX, (v) => `${wrap(-25, 0, v)}%`);

  useAnimationFrame((t, delta) => {
    baseX.set(baseX.get() - 4 * (delta / 1000));
  });

  const copy = (
    <div className="flex shrink-0 items-center whitespace-nowrap" aria-hidden="true">
      {ITEMS.map((item, i) => (
        <span key={`${item}-${i}`} className="flex items-center">
          <span className="mono text-[11px] sm:text-xs tracking-[0.3em] uppercase text-neutral-600">{item}</span>
          <span className="mx-10 w-1 h-1 rounded-full bg-neutral-800" />
        </span>
      ))}
    </div>
  );

  return (
    <section data-testid="client-strip" className="border-y border-white/5 py-6 overflow-hidden">
      <motion.div className="flex w-max" style={{ x }}>
        {copy}
        {copy}
        {copy}
        {copy}
      </motion.div>
    </section>
  );
};
